import { createAsyncThunk } from '@reduxjs/toolkit';
import { getNerobottiThread } from '../services/getNerobottiThread';

/**
 * Reopen a past conversation.
 *
 * The reducer puts the turns back on screen *and* adopts the thread id, which is
 * the half that makes this more than a viewer: the next message sent carries
 * that id, the server loads the same thread's history for the prompt, and the
 * assistant picks the conversation up where it was left rather than meeting it
 * cold. Restoring the pixels without the id would look identical and be a lie.
 */
export const openNerobottiThread = createAsyncThunk(
    'nerobotti/openThread',
    async (threadId) => {
        const data = await getNerobottiThread(threadId);

        return {
            // Echoed from the argument rather than read out of the response, so
            // the id the store adopts is the one that was asked for.
            threadId,
            turns: Array.isArray(data?.turns) ? data.turns : [],
            truncated: Boolean(data?.truncated),
        };
    }
);

export default openNerobottiThread;
